import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApprovedByRoutingModule } from './approved-by-routing.module';
import { ApprovedByListComponent } from './approved-by-list/approved-by-list.component';
import { ApprovedByCreateComponent } from './approved-by-create/approved-by-create.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
  declarations: [ApprovedByListComponent, ApprovedByCreateComponent],
  imports: [
    CommonModule,
    ApprovedByRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    Ng2SmartTableModule
  ]
})
export class ApprovedByModule { }
